var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',_vm._b({attrs:{"value":_setup.telefone_formatado,"maxlength":"15"},on:{"input":_setup.onInput,"focus":_setup.onFocus}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }